import fillStaffKey from './middlewares/fillStaffKey'
import populate from './middlewares/populate'

module.exports = {
  model: 'staffers',
  middlewares: [populate, fillStaffKey],
}



// WEBPACK FOOTER //
// ./src/views/staffers.js